import { ReactElement, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { get } from 'utils/network';
import { ApiRoute, FeatureFlag } from 'config';
import useAsyncEffect from 'hooks/useAsyncEffect';
import useCurrentUser from 'hooks/useCurrentUser';

import CartModel from 'models/Cart';
import type { ICart } from 'models/Cart';
import { CartProvider } from 'contexts/Cart';

import Header from './Header';
import Recipes from './Recipes';
import HeaderSkeleton from './Header/Skeleton';
import RecipesSkeleton from './Recipes/Skeleton';
import ProgramRecipes from './Recipes/ProgramRecipes';
import { Programs } from '../../models/Plan';

function Cart(): ReactElement {
  const { cartId } = useParams();
  // @ts-expect-error TODO: fix null safety
  const [cart, setCart] = useState<CartModel>(null);
  const { reload: reloadUser, currentUser } = useCurrentUser();
  const [filter, setFilter] = useState(currentUser?.subscription?.plan === Programs.JUMPSTART_PROGRAM ? 'programs' : 'view_all');
  const [subFilter, setSubFilter] = useState('');
  const [preferenceFilters, setPreferenceFilters] = useState([]);
  const [filteredResultCount, setFilteredResultCount] = useState(0);
  const areProgramsEnabled = currentUser
    .hasFeatureEnabled(FeatureFlag.PROGRAMS);

  useEffect(() => {
    if (currentUser?.subscription?.plan === Programs.JUMPSTART_PROGRAM && areProgramsEnabled) {
      setFilter('programs');
    } else {
      setFilter('view_all');
    }
  }, [currentUser?.subscription?.plan]);

  const handleFilterClick = (filterArg) => setFilter(filterArg);
  const handleSubFilterClick = (subFilterArg) => setSubFilter(subFilterArg);

  useAsyncEffect(async (isMounted) => {
    document.body.classList.add('is-loading');

    const hasSelectMinimumParam = () => (
      /select_minimum=true/.test(window.location.search)
    );

    const { parsedBody, ok } = await get<ICart>(`${ApiRoute.CARTS}/${cartId}`);

    if (isMounted.current && ok) {
      // @ts-expect-error TODO: fix null safety
      setCart(new CartModel(parsedBody, hasSelectMinimumParam()));
      reloadUser();
    }

    document.body.classList.remove('is-loading');
  }, [cartId]);

  return cart ? (
    <CartProvider value={cart}>
      <Header
        filter={filter}
        subFilter={subFilter}
        onFilterClick={handleFilterClick}
        onSubFilterClick={handleSubFilterClick}
        preferenceFilters={preferenceFilters}
          // @ts-expect-error TODO: fix null safety
        setPreferenceFilters={setPreferenceFilters}
        filteredResultCount={filteredResultCount}
      />
      {filter.toLowerCase() === 'programs'
        ? <ProgramRecipes handleFilterClick={handleFilterClick} />
        : (
          <Recipes
            filter={filter}
            subFilter={subFilter}
            preferenceFilters={preferenceFilters}
            setFilteredResultCount={setFilteredResultCount}
          />
        )}
    </CartProvider>
  ) : (
    <>
      <HeaderSkeleton />
      <RecipesSkeleton />
    </>
  );
}

export default Cart;
